module.exports = __webpack_public_path__ + "static/img/1.64d306f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/1.png
// module id = pMVt
// module chunks = 0